import { render, staticRenderFns } from "./Auto_update.vue?vue&type=template&id=207c600a&scoped=true"
import script from "./Auto_update.vue?vue&type=script&lang=js"
export * from "./Auto_update.vue?vue&type=script&lang=js"
import style0 from "./Auto_update.vue?vue&type=style&index=0&id=207c600a&prod&scoped=true&lang=css"
import style1 from "./Auto_update.vue?vue&type=style&index=1&id=207c600a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207c600a",
  null
  
)

export default component.exports